import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

export default function(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.clientIp`),
        labelMode: this.labelMode,
        dense: true,
        clearable: true,
        details: false,
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
